'use strict';

/**
 * PriceConverter class is used for converting prices to end customer currency on the Storefront
 */
function PriceConverter() {}

/**
 * Generate request body
 */
PriceConverter.prototype.generateRequest = function () {
    this.priceElements.forEach(function (el) {
        var key = el.dataset.originalPrice + '_' + (el.dataset.isDiscount === 'true');
        if (!(key in this.requestDataObj)) {
            this.requestDataObj[key] = {
                originalPrice: el.dataset.originalPrice,
                isDiscount: el.dataset.isDiscount
            };
        }
    }.bind(this));
};

/**
 * Send request body
 * @param {Function} callback - Callback function
 */
PriceConverter.prototype.sendRequest = function (callback) {
    if (Object.keys(this.requestDataObj).length > 0) {
        var httpRequest = new window.XMLHttpRequest();
        httpRequest.open('POST', window.scriptLoaderData.globaleConvertPriceUrl, true);
        httpRequest.setRequestHeader('Content-type', 'application/json');
        httpRequest.onreadystatechange = function () {
            if (httpRequest.readyState === 4 && httpRequest.status === 200) {
                try {
                    this.responseDataObj = JSON.parse(httpRequest.responseText);
                    callback.apply(this);
                } catch (e) {
                    // handle error exceptions
                }
            }
        }.bind(this);
        httpRequest.send(JSON.stringify(this.requestDataObj));
    }
};

/**
 * Replace price value
 */
PriceConverter.prototype.replacePriceValue = function () {
    if (Object.keys(this.responseDataObj).length > 0) {
        this.priceElements.forEach(function (el) {
            var key = el.dataset.originalPrice + '_' + (el.dataset.isDiscount === 'true');
            if (key in this.responseDataObj) {
                // Check if element has data-original-title attribute
                var originalTitle = el.getAttribute('data-original-title');
                if (originalTitle) {
                    // In the data-original-title, replace only the span content with data-original-price
                    var newTitle = originalTitle.replace(/(<span[^>]*data-original-price[^>]*>)([^<]*)(<\/span>)/, function(match, openTag, content, closeTag) {
                        return openTag + this.responseDataObj[key] + closeTag;
                    }.bind(this));
                    el.setAttribute('data-original-title', newTitle);
                } else {
                    // Otherwise, replace innerHTML as before
                    el.innerHTML = this.responseDataObj[key]; // eslint-disable-line no-param-reassign
                }
                
                // Update content attribute with numeric values only if element has it
                if (el.hasAttribute('content')) {
                    // Extract only numeric values from the response data (handle comma separators)
                    var numericValue = this.responseDataObj[key].replace(/[^0-9.,]/g, '').replace(/,/g, '');
                    if (numericValue && !isNaN(numericValue)) {
                        el.setAttribute('content', numericValue);
                    }
                }
            }
        }.bind(this));
    }
};

/**
 * Convert prices
 */
PriceConverter.prototype.convertPrices = function () {
    this.priceElements = document.querySelectorAll('[data-original-price]');
    this.requestDataObj = {};
    this.responseDataObj = {};

    this.generateRequest();
    this.sendRequest(this.replacePriceValue);
};

/**
 * Init function
 */
function init() {
    // convert prices
    if (window.scriptLoaderData && window.scriptLoaderData.globaleConvertPriceUrl) {
        var priceConverter = new PriceConverter();
        priceConverter.convertPrices();
    }
}

if (/complete|interactive|loaded/.test(document.readyState)) {
    // In case the document has finished parsing, document's readyState will
    // be one of "complete", "interactive" or (non-standard) "loaded".
    init();
} else {
    // The document is not ready yet, so wait for the DOMContentLoaded event
    document.addEventListener('DOMContentLoaded', init);
}

module.exports = PriceConverter;
